import React from "react";
import {
  TextField,
  Button,
  Box,
  Grid,
  CircularProgress,
  Alert,
  Stack,
  InputLabel,
} from "@mui/material";
import JSEncrypt from "jsencrypt";
import sha256 from "js-sha256";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { AuthenticationApi } from "../../../API/Authentication/LoginApi";

const Login: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loginError, setLoginError] = useState<string | null>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const navigate = useNavigate();

  const hexToBytes = (hex: string) => {
    const bytes: number[] = [];
    for (let i = 0; i < hex.length; i += 2) {
      bytes.push(parseInt(hex.substr(i, 2), 16));
    }
    return bytes;
  };

  const handleLogin = async () => {
    setLoader(true);
    setLoginError(null);
    try {
      const timestamp = String(Date.now());
      const hash = sha256.sha256(password + timestamp);
      const hashBytes = hexToBytes(hash);
      const hashBase64 = btoa(String.fromCharCode(...hashBytes));
      const data = `${password}:${timestamp}:${hashBase64}`;
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(
        "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg79k2m8PlGNIyJum2uzGqnhdjNqc90SF5FwoOlU7I6Hy6xh36K2qzw1Q5wLcfM+KojFy0xLzKf/u03Wm9S/SmbwvzlXaCq5uYEtVqJBxCz3Y+ZyTRlWyWDJki+OvGYqGbw1EmmKFt2SaOjsE/e+lo6KQpFZwGuaJ1ZKQjCbKRdmkOUAWIjK51a3r8kTnq7XIMf9iXaHX5qvTS/BMcRrXTQ5/JGeuy9OCaJ0S7YrSINZymd0puA0IH87QxDmnUoq+pJwo8l67MFwK7rLyCDSRGwdVY4kLQw8T25k53eoH6+ZUMLydkR4X/ryXYERIw/OwPWpoioHARKzyA/ARA2jkTQIDAQAB"
      );

      const encryptedData = encrypt.encrypt(data);
      if (!encryptedData) throw new Error("Encryption failed. Invalid data.");

      const response = await AuthenticationApi.api.onlineUserAuthentication(
        username,
        encryptedData
      );

      setLoader(false);
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("name", response.data.userDetail.name);
        navigate("/overview");
      } else {
        setLoginError(response.message || "Access Denied");
      }
    } catch (error) {
      // console.error("Login error:", error);
      setLoader(false);
      setLoginError("Invalid Credentials or Network Error");
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleLogin();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box
        sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Grid container sx={{ flex: 1 }}>
          <Grid item xs={false} sm={4} md={6}>
            {/* <div className="flex items-center justify-between">
              <img
                src={"/assets/invoice-logo.svg"}
                alt="Logo"
                className="ml-4 mt-4"
              />
            </div> */}
            <Box
              component="img"
              className="w-full mt-2"
              sx={{
                height: 800,
                maxHeight: { xs: 200, md: 467 },
                maxWidth: { xs: 800, md: 1150 },
                objectFit: "cover",
              }}
              src="/assets/login-bg.svg"
            />
          </Grid>

          <Grid
          item
          sm={8}
          md={6}
          container
          justifyContent="center"
          alignItems="center"
        >
            <Box
              width="100%"
              maxWidth={400}
            >
                <Grid item xs={12}>
               <p className="text-left	font-bold text-3xl text-gray-500">
              Welcome!
            </p>
            <p className="text-left	mb-8 mt-2 text-gray-500">
              Log In to your account
            </p>
            <Stack spacing={1}>
              <InputLabel className="text-left	" htmlFor="email">
                Enter Username
              </InputLabel>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              </Stack>
              </Grid>
              <Grid item xs={12} >
              <Stack spacing={1}>
              <InputLabel className="text-left" htmlFor="email" >
                Enter Password
              </InputLabel>
              <TextField
                type="password"
                variant="outlined"
                margin="normal"
                fullWidth
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              </Stack>
              </Grid>
              {loader ? (
                <CircularProgress style={{ marginTop: "16px" }} />
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  style={{
                    marginTop: "16px",
                    backgroundColor: "#1FCD5B",
                  }}
                >
                  Login
                </Button>
              )}
              {loginError && (
                <Alert severity="error" style={{ marginTop: "16px" }}>
                  {loginError}
                </Alert>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default Login;
